import { useTranslation } from 'react-i18next'
import { ReactElement } from 'react'

interface ContactMethod {
  icon: ReactElement
  titleKey: string
  descriptionKey: string
  href?: string
  isEmail?: boolean
}

const getContactMethods = (): ContactMethod[] => [
  {
    icon: (
      <svg className="w-5 h-5 text-primary mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    titleKey: 'email',
    descriptionKey: 'emailAddress',
    href: 'mailto:contact.us@rtsinv.com',
    isEmail: true
  },
  {
    icon: (
      <svg className="w-5 h-5 text-primary mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
    titleKey: 'chat',
    descriptionKey: 'chatDescription'
  }
]

export default function SupportCard() {
  const { t } = useTranslation('home')
  const contactMethods = getContactMethods()

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
      <div className="flex items-center mb-6">
        <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center mr-4">
          <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        <h3 className="text-xl font-bold text-text-dark">{t('support.title')}</h3>
      </div>
      <p className="text-gray-600 mb-4">
        {t('support.description')}
      </p>
      <div className="space-y-4">
        {contactMethods.map((method, index) => (
          method.href ? (
            <a
              key={index}
              href={method.href}
              className="flex items-center p-3 bg-background-light rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
            >
              {method.icon}
              <div>
                <div className="font-medium text-text-dark">{t(`support.methods.${method.titleKey}`)}</div>
                <div className="text-sm text-gray-600">{t(`support.methods.${method.descriptionKey}`)}</div>
              </div>
            </a>
          ) : (
            <div key={index} className="flex items-center p-3 bg-background-light rounded-lg">
              {method.icon}
              <div>
                <div className="font-medium text-text-dark">{t(`support.methods.${method.titleKey}`)}</div>
                <div className="text-sm text-gray-600">{t(`support.methods.${method.descriptionKey}`)}</div>
              </div>
            </div>
          )
        ))}
      </div>
      <a
        href="https://rtsinv.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 w-full bg-highlight-yellow text-white py-2 rounded-lg hover:bg-highlight-orange transition-colors font-medium text-center block"
      >
        {t('support.button')}
      </a>
    </div>
  )
}